module.exports = __webpack_public_path__ + "img/flank1.154eb09a.png";